import { MetalType } from "../../models/common.model";

export class CommonVoucherModel{
 formName : string;
 paymentGridName : string;
 enableAddStoneDiamond : boolean;
 paymentListGridName : string;
 route : string; 
isLoading:boolean   = false;

 controllerName      : any = {};

 getAllDropdownModel : any = {};
 invoiceDate         : any;
 sundryType          : any;
 salesMode : any;
 isInvoiceNo : boolean = true;
 isbackedDataModelPopup         : boolean = true;
 isJobworkOrder : boolean = false;
 invoiceIdName : any;
 voucherType : any;
 voucherTypeId : any;
 customerTaxTypeName : any;
 noPermissionTooltip : any;
 invoiceCanUpdate : any;
 invoiceCanAdd : any;
 showMetalSection : boolean = true;
 showMetalSectionSimple : boolean = false;
 showMetalSectionViewOnlyPopup : boolean = false;
 showMetalSectionSimpleForce : boolean = false;
 showPaymentSection : boolean = true;
 showCommentSection: boolean = true;
 showTaxSection : boolean = true;
 showTotalSection : boolean = true;
 showPaymentAndReciptVoucherNewDesign : boolean = false;
 isDurationDate : boolean = false;
 showDepartment : boolean = false;
 showVoucherTypeDropdown : boolean = false;
 showAgainstInvoiceDropdown : boolean = false;
 showPaymentListSection : boolean = false;
 showItemListection : boolean = true;
 showAccountLedgerDropdown : boolean = true;
 disableMetalSection : boolean = true;
 showExpensesWithTaxSwitch : boolean = false;
 isAccountLedgerValidRequird: boolean = true;
 showNewInvoiceButton : boolean = true;
 showUploadDocumentButton : boolean = true;
 showSaveInvoiceButton : boolean = true;
 showJournalVouchersPopupIcon : boolean = true;
 defaultActiveMetalTab : any ;
 showTopSection : boolean = true;
 accountLedgerPopUp : boolean = false;
 layawaysPopUp : boolean = false;
 showfixingDirectGridSection: boolean = false;
 showgozUsdRate: boolean = false;
 printBarcodeButton: boolean = false;
 showFromBranchDropdown : boolean = false;
 showToBranchDropdown : boolean = false;
 isRecievedButton: boolean = false;
 isshowLayawaysDropdown: boolean = false;
 isShowFixingType: boolean = false;
 isShowCurrency: boolean = false;
 isShowDueDate: boolean = false;
 isShowReferenceNo: boolean = false;
 isShowAgainstOf: boolean = false;
 isShowSalesperson: boolean = false;
}

export enum FixingType{
    Standard = 1,
    Hedging = 2
}

export const AgainstOfDropdown = {
    salesQuotation : 3,
    deliveryNotes : 2,
    salesOerder: 1
}